import React from 'react';
import LineChart from '../kuroco/LineChart';

const hasValue = (series) => Array.isArray(series) && series.some((v) => v != null);
// 予測の線は、最後の実績の点につながる（1 点）。それより先に値があるときだけ「予測がある」とする
const hasForecast = (series) => Array.isArray(series) && series.filter((v) => v != null).length >= 2;

/**
 * 店舗の KPI ごとのグラフ（ホームと同じ LineChart）。プルダウン（かカードのタップ）で指標を切り替える。
 * data = utils/storeKpis.storeChartData の結果（metrics / metricOrder / chartMonths）。
 * 予測の線は、店舗合計の予測の行があるときだけ。
 * 目標線・目標のラベルは出さない（オーナー 2026-10-22「店舗の目標はいまは要らない」）。
 * storeKpis は target を計算したままなので、出したくなったら下の `target: null` を外す。
 */
export default function StoreKpiChart({ data, metricKey, onChange, loading, error }) {
  const order = data?.metricOrder || [];
  const raw = data?.metrics?.[metricKey] || null;
  const metric = raw ? { ...raw, target: null } : null;

  return (
    <section aria-label="時系列分析">
      <div className="section-title">
        時系列分析
        <span className="muted">タップで指標を切替</span>
      </div>
      <div className="chart-card">
        {loading && order.length === 0 && <div className="sv-cap">読み込み中…</div>}
        {error && order.length === 0 && <div className="sv-cap">推移を読み込めませんでした</div>}
        {!loading && !error && order.length === 0 && <div className="sv-cap">推移のデータがまだありません</div>}
        {order.length > 0 && (
          <>
            <div className="chart-head">
              <select
                className="chart-select"
                aria-label="指標"
                value={metricKey}
                onChange={(e) => onChange?.(e.target.value)}
              >
                {order.map((key) => (
                  <option key={key} value={key}>
                    {data.metrics[key]?.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="chart-canvas">
              <LineChart metric={metric} months={data.chartMonths} />
            </div>
            <div className="chart-legend">
              <span>
                <i className="lg-line" /> 実績（店舗合計）
              </span>
              {hasForecast(metric?.forecast) ? (
                <span>
                  <i className="lg-line dash" /> 現状の予測
                </span>
              ) : (
                <span className="sv-muted">予測は、まだありません</span>
              )}
              {hasValue(metric?.required) && (
                <span>
                  <i className="lg-line need" /> 目標達成に必要
                </span>
              )}
            </div>
          </>
        )}
      </div>
    </section>
  );
}
